import { type IFilterXSSOptions } from "xss";

export const svgXssSettings: IFilterXSSOptions = {
	whiteList: {
		svg: [],
		circle: [],
		rect: [],
		path: [],
		g: [],
		defs: [],
		clipPath: [],
	},
	stripIgnoreTag: true,
	stripIgnoreTagBody: ['script'],
	onTagAttr: (tag, name, value) => {
		const allowedTags = ['svg', 'circle', 'rect', 'path', 'g', 'defs', 'clipPath'];

		if (allowedTags.includes(tag) && value.slice(0, 2) !== "on") {
			return `${name}="${value}"`;
		}

		// For tags not in allowedTags, keep default behavior
		return undefined;
	}
};

export const noTagsXssSettings: IFilterXSSOptions = {
	whiteList: {},
	stripIgnoreTag: true,
	stripIgnoreTagBody: ['script']
};

export const richTextXssSettings: IFilterXSSOptions = {
	whiteList: {
		sub: ["style"],
		sup: ["style"],
		br: ["style"],
		strong: ["style"],
		blockquote: ["style"],
		b: ["style"],
		em: ["style"],
		i: ["style"],
		p: ["style"],
		a: ["rel", "class", "href", "target", "tabindex", "style"],
		h2: ["style"],
		h3: ["style"],
		h4: ["style"],
		h5: ["style"],
		h6: ["style"],
		span: ["style"],
		div: ["style"],
		ul: ["style"],
		li: ["style"],
	},
	css: false,
};